export default {
    title: 'เวลาเข้างานเฉลี่ย',
    weekly: 'รายสัปดาห์',
    mon: 'จ.',
    tue: 'อ.',
    wed: 'พ.',
    thu: 'พฤ.',
    fri: 'ศ.',
    sat: 'ส.',
    sun: 'อา.'
}
